import axios from 'axios';
import { BaseAPI } from './BaseAPI';

export class ApplyAPI extends BaseAPI {
  //提交場所申請
  async ApplySubmit(value, otp, captcha) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/submit?otp=${otp}&captcha=${captcha}`,
      value
    );
    return data;
  }

  //獲取申請詳情
  async ApplyQuery(cardNoOrTaxNo, applicationNo, mobile, otp) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/query?cardNoOrTaxNo=${cardNoOrTaxNo}&applicationNo=${applicationNo}&mobile=${mobile}&otp=${otp}`
    );
    return data;
  }

  //查詢獲取申請詳情
  async QueryDetail(cardNoOrTaxNo, applicationNo, expire, signature) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/sign/query?cardNoOrTaxNo=${cardNoOrTaxNo}&applicationNo=${applicationNo}&expire=${expire}&signature=${signature}`
    );
    return data;
  }

  //第一步檢驗信息
  async ApplyBasic(value, captcha) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/submit/basic?captcha=${captcha}`,
      value
    );
    return data;
  }

  //下载预先通知凭证
  async downloadAdvance(applicationNo, expire, signature) {
    const { data } = await axios.get(
      `${this._getBasePathPublic()}/download/advance?applicationNo=${applicationNo}&expire=${expire}&signature=${signature}`,
      { responseType: 'blob' }
    );
    return data;
  }

  //文件必傳校驗
  async validateDocuments(applicationNo, applicationType, companyType) {
    const { data } = await axios.post(
      `${this._getBasePathPublic()}/submit/documents/${applicationNo}?companyType=${companyType}&applicationType=${applicationType}`
    );
    return data;
  }

}
export default new ApplyAPI({
  prefix: '',
  path: '/public/application',
});
